export * from './types';
export * from './bridge';

import { type AccountsExportClasses, accounts } from './reexport/accounts';
import { type ApiTokensExportClasses, apiTokens } from './reexport/apiTokens';
import { type ApplicationsExportClasses, applications } from './reexport/applications';
import { type ApplicationsGroupsExportClasses, applicationsGroups } from './reexport/applicationsGroups';
import { type ApplicationsInfoExportClasses, applicationsInfo } from './reexport/applicationsInfo';
import { type CampaignsExportClasses, campaigns } from './reexport/campaigns';
import { type DevicesExportClasses, devices } from './reexport/devices';
import { type EmailTemplatesExportClasses, emailTemplates } from './reexport/emailTemplates';
import { type EventsExportClasses, events } from './reexport/events';
import { type GoogleExportClasses, google } from './reexport/google';
import { type IntegrationsExportClasses, integrations } from './reexport/integrations';
import { type ReferralPartnersExportClasses, referralPartners } from './reexport/referralPartners';
import { type TagsExportClasses, tags } from './reexport/tags';
import { type UsersExportClasses, users } from './reexport/users';
import { type DeeplinksExportClasses, deeplinks } from './reexport/deeplinks';
import { type TestDevicesExportClasses, testDevices } from './reexport/testDevices';
import { type FrequencyCappingExportClasses, frequencyCapping } from './reexport/frequencyCapping';

export type RpcServiceClientClasses = {
  accounts: AccountsExportClasses;
  apiTokens: ApiTokensExportClasses;
  applications: ApplicationsExportClasses;
  applicationsGroups: ApplicationsGroupsExportClasses;
  applicationsInfo: ApplicationsInfoExportClasses;
  campaigns: CampaignsExportClasses;
  devices: DevicesExportClasses;
  emailTemplates: EmailTemplatesExportClasses;
  events: EventsExportClasses;
  google: GoogleExportClasses;
  integrations: IntegrationsExportClasses;
  referralPartners: ReferralPartnersExportClasses;
  tags: TagsExportClasses;
  users: UsersExportClasses;
  deeplinks: DeeplinksExportClasses;
  testDevices: TestDevicesExportClasses;
  frequencyCapping: FrequencyCappingExportClasses;
};

type Constructor = new (...args: any[]) => any;

type IsConstructor<T> = T extends Constructor ? InstanceType<T> : T;

type Instances<T> = {
  [K in keyof T]: IsConstructor<T[K]>;
};

export type RpcServiceClientInstances = {
  accounts: Instances<AccountsExportClasses>;
  apiTokens: Instances<ApiTokensExportClasses>;
  applications: Instances<ApplicationsExportClasses>;
  applicationsGroups: Instances<ApplicationsGroupsExportClasses>;
  applicationsInfo: Instances<ApplicationsInfoExportClasses>;
  campaigns: Instances<CampaignsExportClasses>;
  devices: Instances<DevicesExportClasses>;
  emailTemplates: Instances<EmailTemplatesExportClasses>;
  events: Instances<EventsExportClasses>;
  google: Instances<GoogleExportClasses>;
  integrations: Instances<IntegrationsExportClasses>;
  referralPartners: Instances<ReferralPartnersExportClasses>;
  tags: Instances<TagsExportClasses>;
  users: Instances<UsersExportClasses>;
  deeplinks: Instances<DeeplinksExportClasses>;
  testDevices: Instances<TestDevicesExportClasses>;
  frequencyCapping: Instances<FrequencyCappingExportClasses>;
};

export const rpcServiceClient: RpcServiceClientClasses = {
  accounts,
  apiTokens,
  applications,
  applicationsGroups,
  applicationsInfo,
  campaigns,
  devices,
  emailTemplates,
  events,
  google,
  integrations,
  referralPartners,
  tags,
  users,
  deeplinks,
  testDevices,
  frequencyCapping
};
